<template>
  <section class="blog-page">
    <div class="container blog-card">
      <!-- Хлебные крошки -->
      <div class="breadcrumbs">Главная / Блог</div>

      <!-- Заголовок -->
      <h1 class="title">Новости и статьи</h1>

      <!-- Поиск -->
      <div class="search">
        <input
          type="text"
          placeholder="Введите заголовок статьи"
          v-model="query"
        />
        <button @click="filterNews">Поиск</button>
      </div>

      <!-- Список карточек -->
      <div class="grid" v-if="filteredNews.length">
        <div class="card" v-for="post in filteredNews" :key="post.id">
          <img
            class="image"
            :src="post.image || require('@/assets/images/logo_x.svg')"
            alt="preview"
          />
          <div class="info">
            <div class="date">{{ formatDate(post.created_at) }}</div>
            <h3 class="card-title">
              <router-link :to="`/blog/${post.id}`">{{
                post.title
              }}</router-link>
            </h3>
            <p class="excerpt" v-html="truncateContent(post.content)"></p>
            <router-link class="read-btn" :to="`/blog/${post.id}`">
              Читать далее
            </router-link>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup>
import { ref, computed, onMounted } from "vue";
import NewsService from "@/services/news";
import moment from "moment";

const news = ref([]);
const query = ref("");

const filteredNews = computed(() =>
  news.value.filter((post) =>
    post.title.toLowerCase().includes(query.value.toLowerCase())
  )
);

const formatDate = (date) => moment(date).format("D MMMM YYYY");
const truncateContent = (text) =>
  text.length > 120 ? text.slice(0, 120) + "..." : text;

onMounted(async () => {
  const res = await NewsService.all();
  news.value = res.result.reverse();
});

const filterNews = () => {
  // Фильтрация уже происходит через computed
};
</script>

<style scoped>
.blog-page {
  background: #f9fbfd;
  padding: 40px 20px;
}
.container {
  margin: 0 auto;
}
.blog-card {
  box-shadow: 0px 8px 24px 0px rgba(129, 135, 189, 0.15);
  border-radius: 30px;
  background-color: #fff;
  padding: 32px 48px;
}
.breadcrumbs {
  font-size: 20px;
  color: rgba(62, 62, 62, 1);
  margin-bottom: 20px;
}
.title {
  font-size: 45px;
  font-weight: 700;
  margin-bottom: 48px;
  color: rgba(0, 199, 130, 1);
  text-align: center;
}
.search {
  display: flex;
  justify-content: center;
  gap: 12px;
  margin-bottom: 72px;
}
.search input {
  padding: 12px 16px;
  font-size: 16px;
  border-radius: 10px;
  border: 1px solid rgba(62, 62, 62, 0.5);
  width: 70%;
}
.search button {
  padding: 10px 48px;
  background: rgba(18, 152, 106, 1);
  color: white;
  border: none;
  border-radius: 10px;
  font-weight: 400;
  cursor: pointer;
  font-size: 22px;
}

.grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(320px, 1fr));
  gap: 32px;
}
.card {
  background: white;
  border-radius: 10px;
  border: 1px solid rgba(62, 62, 62, 0.3);
  overflow: hidden;
  display: flex;
  flex-direction: column;
}
.image {
  width: 100%;
  height: 180px;
  object-fit: cover;
}
.info {
  padding: 20px;
  display: flex;
  flex-direction: column;
  flex: 1;
}
.date {
  font-size: 15px;
  color: rgba(62, 62, 62, 0.5);
  margin-bottom: 8px;
}
.card-title {
  font-size: 22px;
  font-weight: 700;
  margin-bottom: 8px;
  line-height: 1.3;
}
.card-title a {
  color: rgba(62, 62, 62, 1);
  text-decoration: none;
}
.excerpt {
  font-size: 20px;
  color: rgba(62, 62, 62, 1);
  margin-bottom: auto;
}
.read-btn {
  margin-top: 16px;
  align-self: flex-end;
  background: none;
  color: rgba(62, 62, 62, 1);
  padding: 6px 16px;
  border-radius: 100px;
  font-size: 20px;
  text-decoration: none;
  transition: 0.2s;
  background-color: rgba(230, 242, 253, 1);
}
.read-btn:hover {
  background: #00c37f;
  color: white;
}
</style>
